import api from "@services/api";
import axios from "axios";

interface IUnityService {
  idEmpreendimentoSales: string;
  bairro?: string;
  somenteDisponiveis?: boolean;
  tipologia?: string;
  valorMinimo?: string;
  valorMaximo?: string;
}
interface IListSalesMirror {
  IdEmpreendimentoSales: string;
}
interface IUnityByIdService {
  idEmpreendimentoSales: string;
  IdUnidade: string;
}
interface IGetTypology {
  idEmpreendimentoSales?: string;
  bairro?: string;
}

class UnityService {
  async getUnity({
    idEmpreendimentoSales,
    bairro,
    somenteDisponiveis,
    tipologia,
    valorMaximo,
    valorMinimo,
  }: IUnityService) {
    try {
      const response = await api.get("/unidade/obter", {
        params: {
          idEmpreendimentoSales,
          bairro,
          somenteDisponiveis,
          tipologia,
          valorMaximo,
          valorMinimo,
        },
      });

      return response.data;
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
      return false;
    }
  }

  async getTypology({ idEmpreendimentoSales, bairro }: IGetTypology) {
    try {
      const response = await api.get("/unidade/obter-tipologia", {
        params: { idEmpreendimentoSales, bairro },
      });

      return response.data;
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
      return false;
    }
  }
  async listSalesMirror({ IdEmpreendimentoSales }: IListSalesMirror) {
    try {
      const response = await api.get("/unidade/obter-espelho-de-vendas", {
        params: { IdEmpreendimentoSales },
      });

      return response.data;
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
      return false;
    }
  }
  async getUnityById({ idEmpreendimentoSales, IdUnidade }: IUnityByIdService) {
    try {
      const response = await api.get("/unidade/obter-por-id", {
        params: { idEmpreendimentoSales, IdUnidade },
      });

      return response.data;
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
      return false;
    }
  }
}

const unityServiceInstance = new UnityService();

export default unityServiceInstance;
